export default {
  title: "Preparation calendar:",
  titleInEvent: "Preparation calendar:",

  company: "Complete company profile",
  order:
    "Place a request for publication in the catalogue not later than {date}",
  pass: "Order passes not later than {date}",
  addServices: "Place an order for additional services not later than {date}",
  selectEvent: "Choose an exhibition",
  sendApplication: "Submit an application for participation",
  contract: "Sign a contract (a participant code)"
};
